import { UseOnboardingCompletedListener } from "./onboarding-completed-listener";
import { UsePwaInstallationShownListener } from "./pwa-installation-shown-listener";

/**
 * This component renders no UI. Its sole purpose is to
 * initialize global event listeners for the application.
 * By including this component at a high level in the
 * component hierarchy, we ensure that the event listeners
 * are set up once and remain active throughout the app's lifecycle.
 */

export function GlobalEventProvider() {
  // Event listeners
  UseOnboardingCompletedListener();
  UsePwaInstallationShownListener();

  return null;
}
